"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyElements = void 0;
var EmptyElements_1 = require("./EmptyElements");
Object.defineProperty(exports, "EmptyElements", { enumerable: true, get: function () { return __importDefault(EmptyElements_1).default; } });
//# sourceMappingURL=index.js.map